import { makeStyles } from '@material-ui/core/styles';
import { reskinStyles } from 'core/components/theme/theme-variant';

export const PANEL_WIDTH = 440;
const PANEL_GUTTER = 6;

export default makeStyles((theme) => ({
  card: { padding: theme.spacing(5), minWidth: 0 },
  body: { display: 'block', lineHeight: 1.6, marginTop: theme.spacing(3), overflowWrap: 'anywhere' },
  panel: {
    position: 'fixed',
    right: 0,
    top: 0,
    bottom: 0,
    width: PANEL_WIDTH,
    maxWidth: '100vw',
    background: theme.colorPalette.beige_25,
    borderLeft: `1px solid ${theme.colorPalette.beige_60}`,
    zIndex: 1250,
    display: 'flex',
    flexDirection: 'column',
    boxShadow: theme.shadows[8],
    minWidth: 0,
    outline: 'none'
  },
  closed: { display: 'none' },
  untrapped: { '& > [data-test="sentinelStart"], & > [data-test="sentinelEnd"]': { display: 'none' } },
  // Matches the Staff header height so the two bottom borders line up when docked.
  panelHeader: {
    height: theme.sizes.headerHeight,
    flexShrink: 0,
    padding: theme.spacing(0, 3, 0, PANEL_GUTTER),
    display: 'flex',
    gap: theme.spacing(3),
    alignItems: 'center',
    borderBottom: `1px solid ${theme.colorPalette.beige_60}`
  },
  panelTitle: { margin: 0 },
  // New look: the Tag keeps the outlined Label's text color.
  previewTag: {
    color: theme.colorPalette.green_100,
    ...reskinStyles(theme, { color: theme.labelStyles.outlined.color })
  },
  closeWrapper: { marginLeft: 'auto' },
  close: { color: theme.colorPalette.green_100 },
  panelBody: {
    padding: theme.spacing(5, PANEL_GUTTER),
    overflowY: 'auto',
    overscrollBehavior: 'contain',
    flex: 1,
    minHeight: 0,
    minWidth: 0,
    '& [class*="MuiGrid-item"]': { minWidth: 0 },
    '& [class*="MuiGrid-grid-xs-4"]': { maxWidth: '100%', flexBasis: '100%' }
  },
  source: {
    display: 'grid',
    gap: theme.spacing(1),
    padding: theme.spacing(3, 4),
    background: theme.colorPalette.beige_50,
    borderRadius: theme.sizes.roundCorners,
    marginBottom: theme.spacing(5)
  },
  sourceLabel: {
    fontSize: 12,
    fontWeight: 600,
    letterSpacing: 1,
    textTransform: 'uppercase',
    color: theme.colorPalette.green_75
  },
  sourceValue: { fontSize: 14, color: theme.colorPalette.green_100, overflowWrap: 'anywhere' },
  toolList: { display: 'grid', gap: theme.spacing(2), marginTop: theme.spacing(4) },
  toolButton: {
    display: 'grid',
    gridTemplateColumns: '1fr auto',
    alignItems: 'center',
    rowGap: theme.spacing(1),
    width: '100%',
    padding: theme.spacing(3, 4),
    font: 'inherit',
    textAlign: 'left',
    color: theme.colorPalette.green_100,
    background: theme.colorPalette.white,
    border: `1px solid ${theme.colorPalette.beige_60}`,
    borderRadius: theme.sizes.roundCorners,
    cursor: 'pointer',
    transition: 'border-color 120ms ease, background-color 120ms ease',
    '&:hover': { borderColor: theme.colorPalette.orange_50, background: theme.colorPalette.orange_50_op_08 },
    '&:focus-visible': { outline: `2px solid ${theme.colorPalette.orange_50}`, outlineOffset: 2 }
  },
  toolCategory: {
    gridColumn: 1,
    fontSize: 12,
    fontWeight: 600,
    letterSpacing: 1,
    textTransform: 'uppercase',
    color: theme.colorPalette.green_75
  },
  toolName: { gridColumn: 1, fontSize: 16 },
  draftTag: {
    gridColumn: 2,
    gridRow: '1 / span 2',
    color: theme.colorPalette.green_100,
    ...reskinStyles(theme, { color: theme.labelStyles.outlined.color })
  },
  back: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    padding: 0,
    marginBottom: theme.spacing(4),
    font: 'inherit',
    fontSize: 14,
    color: theme.colorPalette.orange_50,
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    '&:hover': { textDecoration: 'underline' },
    '&:focus-visible': { outline: `2px solid ${theme.colorPalette.orange_50}`, outlineOffset: 2 }
  },
  toolsHeading: { margin: 0, marginBottom: theme.spacing(4) },
  changed: {
    display: 'grid',
    justifyItems: 'start',
    gap: theme.spacing(2),
    padding: theme.spacing(3, 4),
    marginBottom: theme.spacing(4),
    fontSize: 14,
    lineHeight: 1.5,
    color: theme.colorPalette.green_100,
    background: theme.colorPalette.beige_50,
    borderLeft: `3px solid ${theme.colorPalette.orange_50}`,
    borderRadius: theme.sizes.roundCorners
  },
  changedHint: { fontSize: 12, color: theme.colorPalette.green_75 },
  textButton: {
    padding: 0,
    font: 'inherit',
    fontWeight: 600,
    color: theme.colorPalette.orange_50,
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    '&:hover': { textDecoration: 'underline' },
    '&:disabled': { color: theme.colorPalette.beige_90, cursor: 'default', textDecoration: 'none' },
    '&:focus-visible': { outline: `2px solid ${theme.colorPalette.orange_50}`, outlineOffset: 2 }
  },
  footer: {
    flexShrink: 0,
    padding: theme.spacing(3, PANEL_GUTTER),
    borderTop: `1px solid ${theme.colorPalette.beige_60}`,
    fontSize: 12,
    lineHeight: 1.5,
    color: theme.colorPalette.green_75
  }
}));
